import { render } from "./SelectBranch.vue?vue&type=template&id=224eadb0&scoped=true"
import script from "./SelectBranch.vue?vue&type=script&lang=js"
export * from "./SelectBranch.vue?vue&type=script&lang=js"

import "./SelectBranch.vue?vue&type=style&index=0&id=224eadb0&lang=scss&scoped=true"

import exportComponent from "/var/www/development/hai-parahita-dev.aksamedia.co.id/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-224eadb0"]])

export default __exports__